import React from 'react';

import { Grid } from '@ha/dsl';

import EXPERIMENTS from 'ha/constants/experiments';
import { Experiment, Variant } from 'ha/modules/Experiments';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import {
  SearchResultsContentCard,
  useSearchResultsContentCard,
} from './SearchResultsContentCard';
import SearchResultsList from './SearchResultsList';
import { SearchListing } from '../types';

type Props = {
  items: SearchListing[];
};

const SearchResultsListNext: React.FC<Props> = ({ items }) => {
  const { contentCard } = useSearchResultsContentCard(items.length);
  const { md } = useMediaQuery();

  const cardBreakpoint = md ? 12 : 8;
  const topChunk = React.useMemo(
    () => items.slice(0, cardBreakpoint),
    [items, cardBreakpoint],
  );
  const bottomChunk = React.useMemo(
    () => items.slice(cardBreakpoint),
    [items, cardBreakpoint],
  );

  return (
    <Experiment name={EXPERIMENTS.GROWTH486.name}>
      <Variant name="A">
        <SearchResultsList items={items} />
      </Variant>
      <Variant name="B">
        <React.Fragment>
          <SearchResultsList items={topChunk} dataTestLocator=": Top chunk" />

          <Grid
            item
            xs={12}
            key="content-card"
            data-test-locator="Search Results content card"
          >
            {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
            <SearchResultsContentCard card={contentCard!} />
          </Grid>

          {bottomChunk.length > 0 && (
            <SearchResultsList
              items={bottomChunk}
              dataTestLocator=": Bottom chunk"
            />
          )}
        </React.Fragment>
      </Variant>
    </Experiment>
  );
};

export default SearchResultsListNext;
